import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getAllData, deleteIdData } from "../../../lib/lessons"
import {ClassForLessonSelect} from "../../ui/myselect";

export default function AdminLessons() {

  const [lessons, setLessons] = useState([])
  const [classforLesson, setClassForLesson] = useState(9);

  const handleDelete = async (id) => {
    const choice = window.confirm(
      'Are You Sure?'
    );
    if (choice) {
      await deleteIdData(id);
      getDataWithTypeFromParamter();
      console.log("Delete", id);
      //router.refresh();
    }

  };

  async function getDataWithTypeFromParamter() {
    //const cats = await  getDataWithType("APPCHECK");
    //setCategory(cats);
    /*
    const slct = await  getDataWithTypeForSelect("APPCHECK");
    setOptions(slct);
    setCategory(slct[0]);
    getDatafromAppCheck(slct[0].id);
    */
    //console.log("option",options);
  }

  async function getDatafromAppCheck(catg) {
   const lesson = await getAllData(catg);
      //console.log("lesson",lesson.filter(cat => cat.class == catg));
      setLessons(lesson.filter(cat => cat.class == catg));

  }


  useEffect(() => {
    getDataWithTypeFromParamter();
    //console.log("useEffect 1");
  }, [])


  



  useEffect(() => {
    //getDataWithCategory(category[0].id)
    //setPrivacy({ label: category[0].pname, value: category[0].id });
    /*
    category.map(function (cat) {
      options.push({ label: cat.pname, value: cat.id })
    })
    *//*
    setOptions([
      ...options,
      {
        key: window.crypto.randomUUID(),
        text,
        value
      }
    ]);
    */
    //console.log("privacy",privacy);
    if (classforLesson !== null)
      {
        getDatafromAppCheck(classforLesson);
      }
  }, [classforLesson])

  return (
            <div className="col-xl-9 col-md-8">
              <div className="settings-widget profile-details">
                <div className="settings-inner-blk p-0">
                  <div className="profile-heading">
                    <h3>Lessons</h3>
                    <div className="new-address">
                      <div className="row">
                        <div className="col">
                          <div className="mb-0">
                            <label className="form-label">
                             Class
                            </label>
                            <ClassForLessonSelect value={classforLesson}  setValue = {setClassForLesson} name={"ClassForLessonSelect"} />
                          </div>
                        </div>
                        <div className="col"> </div>
                        <div className="col">
                          <Link
                            to="/admin/admin-lessons-edit/Add/0"
                            className="btn btn-dark btn-dark-1"
                          >
                            Create New Lesson
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="comman-space pb-0">
                    <div className="settings-invoice-blk table-responsive">
                      {/* Invoice info */}
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Id</th>
                            <th>Lesson Name</th>
                            <th>IsActive</th>
                            <th>&nbsp;</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lessons.map(function (data) {
                            return (
                              <tr key={data.id}>
                                <td>
                                  <Link
                                    to="#"
                                    className="invoice-no"
                                  >
                                    {data.id}
                                  </Link>
                                </td>
                                <td>{data.lessonname}</td>
                                <td>{data.isActive ? <span className="badge info-low">True</span> : <span className="badge info-high">False</span>}</td>
                                <td>
                                  <div className="profile-share d-flex align-items-center justify-content-end">
                                    <Link to={`/admin/admin-lessons-edit/${data.id}/${classforLesson}`} className="btn btn-success btn-sm">
                                      Update  
                                    </Link>
                                    <button className="btn btn-danger btn-sm" onClick={() => handleDelete(data.id)}>
                                      Delete
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                      {/* Invoice info */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
  );
}
